export default "__VITE_ASSET__CteuGGjT__"